import {InjectionToken} from '@angular/core';
import {ITreeTranslations} from '../interfaces/ITreeTranslations';

export const TREE_TRANSLATION_TOKEN = new InjectionToken<ITreeTranslations>('[TREE[ Translation service');
